module.exports = __webpack_public_path__ + "static/media/A18.c2886476.jpg";